import { render, staticRenderFns } from "./ConvenioPagos.vue?vue&type=template&id=b637187e"
import script from "./ConvenioPagos.vue?vue&type=script&lang=js"
export * from "./ConvenioPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports